import { Outlet } from 'react-router-dom';
import useCreateEditProjectLayout from './use-create-edit-project-layout';
import { useAppSelector } from '@/store/hooks';
import useCloneListsComplete from '@/connection/hooks/use-clone-lists-complete';
import useMergeListsComplete from '@/connection/hooks/use-merge-lists-complete';
import useUploadListComplete from '@/connection/hooks/use-upload-list-complete';
import useAudienceError from '@/connection/hooks/use-audience-error';
import { selectProjectChannel } from '@/store/slices/project/selectors';

const ProjectRoot = () => {
  const channel = useAppSelector(selectProjectChannel);

  const isProjectDetailsAvailable = true;

  useCreateEditProjectLayout({ preventUpdate: !isProjectDetailsAvailable });

  useCloneListsComplete(channel);
  useMergeListsComplete(channel);
  useAudienceError(channel);
  useUploadListComplete(channel);

  return <Outlet />;
};

export default ProjectRoot;
